let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jmWj5")).then(() => parcelRequire('bFdEh'));